export * from './BaseComposite.vue';
export { default } from './BaseComposite.vue';
